module.exports = __webpack_public_path__ + "static/media/sp.7d1fbffc.webp";